export const endpoints = {
  getPartitionsWithEquipments:
    '/account/:accountId/getPartitionsWithEquipments',
}
